import React, { useEffect, useState }  from 'react';
import '../../styles/toggler.scss'

const Toggler = ({subTitle, eqv,isOn, setIsOn}) => {

    
    return (
        <div 
        className={`toggler_wrap ${subTitle === eqv ? 'toggler_wrap_toggler_active' : ''}`}  
        // onClick={()=>setIsOn(state => !state)}
        >
            <div className={`toggler_check ${isOn ? 'toggler_on' : 'toggler_off'}`}></div>
        </div>
    );
};

export default Toggler;